import { asyncToGenerator as _asyncToGenerator, objectSpread2 as _objectSpread2 } from "../../_virtual/_rollupPluginBabelHelpers.js";
import AnnotationField from "../../stores/AnnotationField.js";
import "../../types/index.js";
import { useQuery } from 'react-query';
import DocumentResource from "./resources/DocumentResource.js";

var fetchDocumentAndAnnotations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_, _ref) {
    var id, documentResource, annotationFields;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = _ref.documentId;
            _context.next = 3;
            return DocumentResource.includes(['parties', 'parties.signature', 'autofill_data', 'autofill_data.fields', 'manual_data', 'manual_data.fields', 'manual_data.parties', 'signing_data', 'signing_data.fields', 'signing_data.parties']).find(id);

          case 3:
            documentResource = _context.sent.data;
            annotationFields = [];
            documentResource.autofillData.forEach(function (dataResource) {
              var data = {
                id: dataResource.id,
                dataType: dataResource.dataType,
                sourceKey: dataResource.sourceKey,
                value: dataResource.value,
                valueType: 'string'
              };
              dataResource.fields.forEach(function (fieldResource) {
                annotationFields.push(new AnnotationField(_objectSpread2(_objectSpread2({}, fieldResource), {}, {
                  data: data
                })));
              });
            });
            documentResource.manualData.forEach(function (dataResource) {
              var valueType = dataResource.valueType;
              var data = {
                id: dataResource.id,
                dataType: dataResource.dataType,
                valueType: valueType,
                value: valueType === 'boolean' ? dataResource.value === 'true' : dataResource.value,
                parties: dataResource.parties,
                fontSize: dataResource.fontSize
              };
              dataResource.fields.forEach(function (fieldResource) {
                annotationFields.push(new AnnotationField(_objectSpread2(_objectSpread2({}, fieldResource), {}, {
                  data: data
                })));
              });
            });
            documentResource.signingData.forEach(function (dataResource) {
              var signedAt = dataResource.signedAt;
              var partyWithSignature = dataResource.parties.find(function (party) {
                return party.signature;
              });
              var value = '';

              if (signedAt && (partyWithSignature === null || partyWithSignature === void 0 ? void 0 : partyWithSignature.signature)) {
                var _partyWithSignature$s = partyWithSignature.signature,
                    fullName = _partyWithSignature$s.fullName,
                    initials = _partyWithSignature$s.initials;
                value = dataResource.valueType === 'signature' ? fullName : initials;
              }

              var data = {
                id: dataResource.id,
                dataType: dataResource.dataType,
                valueType: dataResource.valueType,
                value: value,
                parties: dataResource.parties,
                signedAt: signedAt ? new Date(signedAt) : undefined,
                fontSize: dataResource.fontSize
              };
              dataResource.fields.forEach(function (fieldResource) {
                annotationFields.push(new AnnotationField(_objectSpread2(_objectSpread2({}, fieldResource), {}, {
                  data: data
                })));
              });
            });
            return _context.abrupt("return", {
              documentResource: documentResource,
              annotationFields: annotationFields
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchDocumentAndAnnotations(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var useGetDocument = function useGetDocument(documentId, queryConfig) {
  var _useQuery = useQuery([DocumentResource.jsonapiType, {
    documentId: documentId
  }], fetchDocumentAndAnnotations, _objectSpread2({
    refetchOnWindowFocus: false
  }, queryConfig)),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      error = _useQuery.error;

  return {
    documentResource: data === null || data === void 0 ? void 0 : data.documentResource,
    annotationFields: data === null || data === void 0 ? void 0 : data.annotationFields,
    isLoading: isLoading,
    error: error
  };
};

export default useGetDocument;